import { render, staticRenderFns } from "./humanity.vue?vue&type=template&id=033a8bbe&scoped=true&"
import script from "./humanity.vue?vue&type=script&lang=js&"
export * from "./humanity.vue?vue&type=script&lang=js&"
import style0 from "./humanity.vue?vue&type=style&index=0&id=033a8bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a8bbe",
  null
  
)

export default component.exports